
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/experimental-api/css-theme-variables",
      function () {
        return require("private-next-pages/system/experimental-api/css-theme-variables.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/experimental-api/css-theme-variables"])
      });
    }
  